import React from 'react'
import SEO from '../../../common/SEO';
import HeaderTwo from '../../../common/header/HeaderTwo';
import FooterOne from '../../../common/footer/FooterOne';
import EdgeAIBanner from '../../../components/products/edge-ai/EdgeAIBanner';
import MEAProductFamily from '../../../components/products/edge-ai/MEAProductFamily';
import MEAKeyFeatures from '../../../components/products/edge-ai/MEAKeyFeatures';
import MEAIndustryApplications from '../../../components/products/edge-ai/MEAIndustryApplications';

const EdgeAI = () => {

  return (
    <>
      <SEO
				title="Edge AI"
				description="Deploy intelligent systems at the edge with our MEA (Machine Edge Analytics) product family."
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <EdgeAIBanner />
      <MEAProductFamily />
      <MEAKeyFeatures />
      <MEAIndustryApplications />
      <FooterOne />
    </>
  )
}

export default EdgeAI;